import { apiGet, apiPost } from './default'

function checkCP(response) {
    return apiGet(API_PORTAL + '/sso/validate');
}

function getConId(data, token) {
    return apiGet(`${API_RESPONSE}/bonds/index.php?cusip=${data}&token=${token}`);
}

function getIserverInfo(response) {
    return apiGet(API_BONDS + '/iserver/accounts');
}

function getSecdef(data, signedIn) {
    return apiPost(API_BONDS + '/trsrv/secdef', data);
}

function getSnapshot({conids, fields, since=1}) {
    let query = '/iserver/marketdata/snapshot?conids=' + conids + '&since=' + since;
    if (fields) {
        query += '&fields=' + fields;
    }
    return apiGet(API_BONDS + query);
}

function getTotals(data) {
    return apiPost(API_BONDS + '/hmds/scanner/totals', { list: data });
}

function logOut() {
    return apiPost(API_RESPONSE + '/bonds/logout.php');
}

function searchBonds(data) {
    return apiPost(API_BONDS + '/hmds/scanner', data);
}

function scannerParams(response) {
    return apiGet(API_BONDS + '/hmds/scanner/params');
}

function unsubscribeAll(response) {
    return apiGet(API_BONDS + '/iserver/marketdata/unsubscribeall');
}


export default {
    checkCP,
    getConId,
    getIserverInfo,
    getSecdef,
    getSnapshot,
    getTotals,
    logOut,
    scannerParams,
    searchBonds,
    unsubscribeAll
}
